var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg40BillionNormalstage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_729_98)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M92.5697 65.1421H70.2875C68.3941 65.1421 66.8573 63.6053 66.8573 61.7119C66.8573 61.177 66.9785 60.66 67.221 60.1786L68.9361 56.7484C69.5209 55.5788 70.6976 54.855 72.0026 54.855H90.8582C92.1632 54.855 93.3399 55.5788 93.9247 56.7484L95.6398 60.1786C95.8823 60.66 96.0035 61.177 96.0035 61.7119C96 63.6053 94.4631 65.1421 92.5697 65.1421ZM90.8546 58.2852H71.9991L70.284 61.7154H92.5733L90.8546 58.2852Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87.5386 96H75.3188C73.5217 96 72.017 94.5951 71.8957 92.8015L69.931 63.5448L73.3541 63.313L75.3188 92.5698H87.5386L89.5033 63.313L92.9264 63.5448L90.9617 92.8015C90.8404 94.5951 89.3357 96 87.5386 96Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.8228 82.2863H6.85689C3.07365 82.2863 0 79.2091 0 75.4294V30.8579C0 27.0746 3.07365 24.001 6.85689 24.001H16.6519V27.4312H6.85689C4.96705 27.4312 3.42666 28.968 3.42666 30.8614V75.433C3.42666 77.3228 4.96349 78.8632 6.85689 78.8632H72.8228V82.2863Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1445 56.5702H73.7143V30.8578C73.7143 28.9679 72.1774 27.4275 70.284 27.4275H67.3387V23.9973H70.284C74.0673 23.9973 77.1409 27.071 77.1409 30.8542V56.5702H77.1445Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8587 96H22.2858C20.396 96 18.8556 94.4632 18.8556 92.5698C18.8556 88.7865 21.9292 85.7129 25.7125 85.7129H51.4285C55.2117 85.7129 58.2854 88.7865 58.2854 92.5698C58.2854 94.4632 56.7485 96 54.8587 96ZM25.716 89.1431C23.8262 89.1431 22.2858 90.6799 22.2858 92.5733H54.8587C54.8587 90.6835 53.3219 89.1431 51.4285 89.1431H25.716Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.2288 79.5441L41.4874 81.6001L46.6306 88.4577L49.372 86.4017L44.2288 79.5441Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.9105 79.5402L27.769 86.3987L30.5107 88.454L35.6522 81.5955L32.9105 79.5402Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72.0026 66.8574H1.71509V70.2876H72.0026V66.8574Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.8551 8.57202H41.1414V12.0022H54.8551V8.57202Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.7155 8.57202H58.2853V12.0022H61.7155V8.57202Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1414 41.1414H18.8556V44.5716H41.1414V41.1414Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.8564 32.573H35.9995V36.0032H42.8564V32.573Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5716 24.001H37.7147V27.4312H44.5716V24.001Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.9577 35.9996H19.583L22.3144 24.001H33.6641L30.9577 35.9996ZM23.8797 32.573H28.2156L29.3781 27.4312H25.0528L23.8797 32.573Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.5155 41.1414H46.2866V44.5716H59.5155V41.1414Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3837 27.695L85.2316 26.3472C85.4705 25.7909 85.6844 25.363 85.9019 24.9316C86.0802 24.5786 86.2585 24.222 86.4582 23.7727L89.6031 25.1384C89.3749 25.659 89.1681 26.0726 88.9649 26.4791C88.7759 26.8499 88.5905 27.2172 88.3837 27.695Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.491 49.9202L87.1427 49.175C87.3353 48.3192 87.428 47.3743 87.428 46.2867C87.428 43.263 86.7184 41.8403 85.8947 40.1965C85.0069 38.4207 84.0013 36.4061 84.0013 32.5729C84.0013 31.9917 84.0227 31.4533 84.0655 30.9541L87.4815 31.2429C87.4494 31.653 87.428 32.0951 87.428 32.5729C87.428 35.5967 88.1376 37.0194 88.9613 38.6632C89.8491 40.4389 90.8547 42.4536 90.8547 46.2867C90.8582 47.6239 90.737 48.8148 90.491 49.9202Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.0009 60.0005H7.08508L15.9352 21.1448C16.4701 18.7878 18.5311 17.144 20.9486 17.144H54.8551V20.5743H20.9486C20.1428 20.5743 19.4546 21.1234 19.2763 21.9078L11.3818 56.5738H24.0009V60.0005Z",
    fill: "#B3B3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.5822 60.0004H22.2858V56.5702H41.8438L49.8417 21.159C50.3694 18.7949 52.4304 17.1404 54.8551 17.1404C57.6898 17.1404 59.9969 19.4475 59.9969 22.2822C59.9969 22.6459 59.9541 23.0132 59.8685 23.4018L56.638 37.5863C56.5916 37.8002 56.5666 38.0142 56.5666 38.2353C56.5666 39.8398 57.886 41.1449 59.5119 41.1449C61.0095 41.1449 62.3146 40.0146 62.6854 38.3922L70.6726 3.43023H32.8902L30.519 13.8314L27.1779 13.0684L30.1553 0H74.9729L66.0301 39.1517C65.3062 42.343 62.6248 44.5716 59.5155 44.5716C56.0033 44.5716 53.1435 41.7297 53.1435 38.2353C53.1435 37.761 53.197 37.2832 53.304 36.8268L56.531 22.653C56.5595 22.5211 56.5738 22.3999 56.5738 22.2858C56.5738 21.3409 55.8071 20.5707 54.8587 20.5707C54.0528 20.5707 53.3646 21.1198 53.1899 21.9114L44.5822 60.0004Z",
    fill: "#B3B3B3"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_729_98"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 96,
    height: 96,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg40BillionNormalstage);
export default __webpack_public_path__ + "static/media/$40_Billion_Normalstage.bc92e4a5ccd719357d29b6c6ca051950.svg";
export { ForwardRef as ReactComponent };